import React, { Fragment, useState } from "react"
import {
    Dropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
    FormGroup,
    Input,
    Label,
} from 'reactstrap'
import { Icon } from "../../../components/Component";



const MultipleQuaterNew = ({ setSelectedOptions, selectedOptions }) => {
    
    const [dropdownOpen, setDropdownOpen] = useState(false);

    const options = [
        { label: 'Quarter 1 (Apr - Jun)', value: 4 },
        { label: 'Quarter 2 (Jul - Sep)', value: 7 },
        { label: 'Quarter 3 (Oct - Dec)', value: 10 },
        { label: 'Quarter 4 (Jan - Mar)', value: 1 },
    ];

    const toggle = () => setDropdownOpen((prevState) => !prevState);

    const handleCheckboxChange = (event) => {
        const value = parseInt(event.target.value, 10);
        setSelectedOptions((prevState) =>
            prevState.includes(value)
                ? prevState.filter((option) => option !== value)
                : [...prevState, value]
        );
    };

    const renderSelectedOptions = () => {
        if (selectedOptions.length > 0) {
            return ` ${selectedOptions.length } QUATER SELECTED `;
        }
        else {
            return 'SELECT QUATERS';
        }
    };
    return (
        <Fragment>
            {/*<Dropdown isOpen={dropdownOpen} toggle={toggle} style={{ display: 'inline-block', width: '100%' }} >
                <DropdownToggle caret style={{ backgroundColor: 'white', color: 'black', padding: '10px 20px', textAlign: 'left' }}>
                    {renderSelectedOptions()}
                </DropdownToggle>
                <DropdownMenu style={{ backgroundColor: 'white', padding: '10px', width: '100%' }}>
                    {options.map((option) => (
                        <DropdownItem key={option} toggle={false} style={{ color: 'black', padding: '10px' }}>
                            <FormGroup check>
                                <Label check>
                                    <Input
                                        type="checkbox"
                                        value={option.value}
                                        checked={selectedOptions.includes(option.value)}
                                        onChange={handleCheckboxChange}
                                    />
                                    {option.label}
                                </Label>
                            </FormGroup>
                        </DropdownItem>
                    ))}
                </DropdownMenu>
            </Dropdown>*/}
            <Dropdown isOpen={dropdownOpen} toggle={toggle}  >

{/*                <DropdownToggle className="form-control" caret style={{ backgroundColor: '#fff', color: '#3c4d62', fontSize: "0.8125rem ", padding: '0.4375rem 1rem', textAlign: 'left', border: "1px solid #dbdfea", borderRadius: "4px" }}>
                    {renderSelectedOptions()} <svg style={{ marginLeft: 10, marginRight: -5, fontSize:15}} xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-down" viewBox="0 0 16 16">
                        <path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708" />
                    </svg>
                  
                </DropdownToggle>*/}
                <DropdownToggle className="form-control" caret style={{ backgroundColor: '#fff', color: '#3c4d62', fontSize: "0.8125rem ", padding: '0.5rem 1rem', textAlign: 'left', border: "1px solid #dbdfea", borderRadius: "4px"  , minHeight:40 , marginTop:5}}>

                    {renderSelectedOptions()}
                  
                    <svg style={{ marginLeft: 40, marginRight: -5, fontSize: 15 }} xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-down" viewBox="0 0 16 16">
                        <path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708" />
                    </svg>
                </DropdownToggle>
              {/*  <DropdownToggle style={{ }} >
                

                    <option  >{renderSelectedOptions()}  </option>

                   

                

                </DropdownToggle>*/}
                <DropdownMenu style={{ backgroundColor: 'white', minWidth: "100%" }}>
                    {options.map((option) => (
                        <DropdownItem key={option} toggle={false} style={{ color: 'black', borderColor: 'white', padding: '10px', fontSize: 13}}>
                            <FormGroup check>
                                <Label check>
                                    <Input
                                        type="checkbox"
                                        value={option.value}
                                        checked={selectedOptions.includes(option.value)}
                                        onChange={handleCheckboxChange}
                                    />
                                    {option.label}
                                </Label>
                            </FormGroup>
                        </DropdownItem>
                    ))}
                </DropdownMenu>
            </Dropdown>

         
          
        </Fragment>

    )

}
export default MultipleQuaterNew